import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface PropertyUsp2xPhotoModel extends BaseModel {
  variables?: { [key: string]: string } | PropertyUsp2xPhotoVariables;
}

export interface PropertyUsp2xPhotoVariables {
  PropertyUsp2x1Image: string;
  PropertyUsp2x2Image: string;
  PropertyUsp2x1ImageHref: string;
  PropertyUsp2x2ImageHref: string;
  PropertyUsp2x1ImageAlt: string;
  PropertyUsp2x2ImageAlt: string;
  PropertyUsp2xName: string;
  PropertyUsp2x1Usp: string;
  PropertyUsp2x2Usp: string;
  PropertyUsp2x3Usp: string;
  PropertyUsp2xCtaLink: string;
  PropertyUsp2xCtaText: string;
  PropertyUsp2x1ImageHrefSegmentRegex: string;
  PropertyUsp2x2ImageHrefSegmentRegex: string;
}

export class PropertyUsp2xPhotoInitVariables implements PropertyUsp2xPhotoVariables {
  PropertyUsp2x1Image = '';
  PropertyUsp2x2Image = '';
  PropertyUsp2x1ImageHref = '';
  PropertyUsp2x2ImageHref = '';
  PropertyUsp2x1ImageAlt = '';
  PropertyUsp2x2ImageAlt = '';
  PropertyUsp2xName = '';
  PropertyUsp2x1Usp = '';
  PropertyUsp2x2Usp = '';
  PropertyUsp2x3Usp = '';
  PropertyUsp2xCtaLink = '';
  PropertyUsp2xCtaText = '';
  PropertyUsp2x1ImageHrefSegmentRegex = '';
  PropertyUsp2x2ImageHrefSegmentRegex = '';
}

export class PropertyUsp2xPhotoInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PropertyUsp2xPhotoInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
